import React, { useEffect, useState, createContext, useContext } from "react";

import { AuthContext } from "./authContext";

import lbl from "../data/Labels.json";

import db from "../services/query";

export const YearContext = createContext();

YearContext.displayName = "EntryYearContext";

export const YearProvider = ({ children }) => {
  const [entryYear, setEntryYear] = useState(null);
  const [pending, setPending] = useState(true);

  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!currentUser) {
        if (!cancelled) setPending(false);
        return;
      }
      try {
        const { data } = await db.getAll("calendar/currentEntryYear");
        if (!cancelled) {
          setEntryYear(data?.data?.entry_year_id ?? null);
        }
      } catch (_e) {
        if (!cancelled) setEntryYear(null);
      } finally {
        if (!cancelled) setPending(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [currentUser]);

  if (pending) return <div className="loading">{lbl.Loading}</div>;

  return (
    <YearContext.Provider
      value={{
        entryYear,
        setEntryYear,
      }}
    >
      {children}
    </YearContext.Provider>
  );
};
